import React from 'react'

function Notifications() {
  return (
    <div>
      
    </div>
  )
}

export default Notifications
